export default __webpack_public_path__ + "static/media/AASMLogo.414f5b40.png";